var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-screen sm:w-auto px-4 py-6 sm:px-6 sm:py-6 gap-5"},[(_vm.$route.name === 'Compound')?_c('TableCompound'):_c('TableProtocols')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }